<template>
  <div class="square__shrink--container">
    <div style="margin-bottom: 10px">
      <p class="f-ui-1-bold">
        {{ title }}
      </p>
    </div>
    <div
      ref="shrink__container"
      class="square__shrink-content--container"
      :style="{ height: `${containerSize}px` }"
    >
      <div
        v-for="(square, idx) in shownItems"
        :key="square.scenario"
        class="squares"
        :class="[
          `square-${idx}`,
          `background-${square.color}`,
          `corner-${pos}`,
        ]"
        :style="{
          width: `${(containerSize * square.value) / max}px`,
          height: `${(containerSize * square.value) / max}px`,
        }"
      >
        <div>
          <p
            class="f-ui-2-bold"
            :class="[
              'square__shrink--label',
              `text__pos--${pos}`,
              { hide: square.value <= 0.05 },
              { 'text__pos--offset': square.offset },
            ]"
            :style="{
              left: `${
                square.offset ? (containerSize * square.value) / max : ''
              }px`,
              top: `${square.offset ? '-20px' : ''}`,
            }"
          >
            {{ square.value.toFixed(2) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
export default {
  data() {
    return { containerSize: 0, shownItems: [], showLabel: false };
  },
  props: {
    data: {
      type: Array,
    },
    title: {
      type: String,
    },
    max: {
      type: Number,
      default: 3,
    },
    /**
     * btm-l, btm-r, top-l, top-r
     */
    pos: {
      type: String,
      default: "btm-l",
    },
    label: {
      type: Boolean,
      default: false,
    },
    smaller: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    window.addEventListener("resize", this.resize);
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  mounted() {
    let container = this.$refs.shrink__container;
    let startValue = Math.max(...this.data.map((t) => t.value));
    this.containerSize = container.clientWidth;

    this.shownItems = this.data.map((d) => ({
      ...d,
      color: "historic",
      value: startValue,
    }));

    let values = {
      Electricity: [
        [0.75, 0.66, 0.66, 0.66],
        [0.75, 0.66, 0.29, 0.29],
        [0.75, 0.66, 0.29, 0.02],
      ],
      "Clean cooking": [
        [2.38, 1.88, 1.88, 1.88],
        [2.38, 1.88, 0.78, 0.78],
        [2.38, 1.88, 0.78, 0.02],
      ],
    };

    let colors = [
      ["historic", "STEPS", "STEPS", "STEPS"],
      ["historic", "STEPS", "APS", "APS"],
      ["historic", "STEPS", "APS", "NZE"],
    ];

    this.shownItems.forEach((item, i) => {
      gsap
        .timeline()
        .to(item, {
          value: values[this.title][0][i],
          color: colors[0][i],
          delay: i * 0.1,
        })
        .to(item, {
          value: values[this.title][1][i],
          color: colors[1][i],
          delay: i * 0.1,
        })
        .to(item, {
          value: values[this.title][2][i],
          color: colors[2][i],
          delay: i * 0.1,
        });
    });
  },
  methods: {
    resize() {
      let container = this.$refs.shrink__container;
      this.containerSize = container.clientWidth;
    },
  },
};
</script>

<style scoped>
.square__shrink--container {
  height: 100%;
  width: 100%;
  padding: 5px;
  display: flex;
  flex-flow: column;
}
.square__shrink-content--container {
  position: relative;
  width: 100%;
}
.squares {
  position: absolute;
  border-radius: 5px 5px 0 0;
}
.corner-btm-l {
  bottom: 0;
  left: 0px;
}
.corner-btm-r {
  bottom: 0;
  right: 0px;
}
.corner-top-l {
  top: 0;
  left: 0px;
}
.corner-top-r {
  top: 0;
  right: 0px;
}
.hide {
  opacity: 0;
}
.square__shrink--label {
  margin-top: 5px;
  min-width: 32px;
}
.text__pos--offset {
  position: absolute;
}
.text__pos--btm-l {
  text-align: right;
  margin-right: 5px;
}
.text__pos--btm-r {
  margin-left: 5px;
}
.text__pos--top-r {
}
.text__pos--top-l {
}
</style>
